import React from 'react';
import PropTypes from 'prop-types';

import { observer } from 'mobx-react';

import Lottie from 'react-lottie';
import wfLoader from 'assets/lotties/wf-loader-black.json';

import { LoadingStyled, TextStyled } from './loading.styled';

const Loading = observer(props => {
  const {
    isLayoutCentered = true,
    text = '',
    paused = false,
    visible = true,
    noText = false,
  } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    renderer: 'svg',
    animationData: wfLoader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  if (!visible) {
    return null;
  }
  if (paused) {
    defaultOptions.autoplay = false;
  }
  return (
    <LoadingStyled
      data-test-id='loadingSpinner'
      isLayoutCentered={isLayoutCentered}
      role='alert'
      aria-live='assertive'
      canvasWidth={props.canvasWidth}
    >
      <Lottie
        options={defaultOptions}
        isPaused={paused}
        height={60}
        width={60}
      />
      {!noText && <TextStyled>{text}</TextStyled>}
      {props.children}
    </LoadingStyled>
  );
});
export default Loading;

Loading.propTypes = {
  isLayoutCentered: PropTypes.bool,
  text: PropTypes.string,
  paused: PropTypes.bool,
};
